import { render, staticRenderFns } from "./TemplateHeader.vue?vue&type=template&id=e852dbce&scoped=true&"
import script from "./TemplateHeader.vue?vue&type=script&lang=ts&"
export * from "./TemplateHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateHeader.vue?vue&type=style&index=0&id=e852dbce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e852dbce",
  null
  
)

export default component.exports